import { Resources } from '@shared/localizations/Resources';
import { TableQuantityTotalMode } from '@shared/utils/Table/Totals/TableQuantityTotalMode.types';
import { PlacedFrom } from '@shared/utils/Trading/PlacedFrom';
import { PositionActionEnum } from '@shared/utils/Trading/PositionActionEnum';
import { getActionEnability, getActionVisibility, processAction } from './PositionsPanelActionsProcessor';
import { SvgIconType } from '../../../elements/SvgIcon/SvgIconType';
import { createGroupByContextMenuItem } from '../../../elements/Table/Helpers/ContextMenuHelper';
// #region Trading actions
function getTradingActionContextMenuItemEnability(action, params, isEmptySelection, emptySelectionReason) {
    const result = { isDisabled: isEmptySelection, disabledReason: isEmptySelection ? emptySelectionReason : null };
    if (result.isDisabled === false) {
        const actionEnability = getActionEnability(action, params.allPositions, params.selectedPositions, params.tradingProvider);
        if (actionEnability.isAllowed === false) {
            result.isDisabled = true;
            result.disabledReason = actionEnability.notAllowedReason;
        }
    }
    return result;
}
function createCloseContextMenuItems(params, isEmptySelection, emptySelectionReason) {
    const items = [];
    if (!Resources.isHidden('panel.positions.menu.Close')) {
        const contextMenuItemEnability = getTradingActionContextMenuItemEnability(PositionActionEnum.ClosePositionMkt, params, isEmptySelection, emptySelectionReason);
        items.push({
            type: 'item',
            id: 'close',
            icon: SvgIconType.ClosePositionByMkt,
            text: Resources.getResource('panel.positions.menu.Close'),
            disabled: contextMenuItemEnability.isDisabled,
            disabledReason: contextMenuItemEnability.disabledReason,
            onClick: () => processAction(PositionActionEnum.ClosePositionMkt, params.allPositions, params.selectedPositions, params.appSettings, params.tradingProvider, params.applicationScreensProvider, PlacedFrom.WEB_POSITIONS_PANEL_CONTEXT_MENU)
        });
    }
    if (!Resources.isHidden('panel.positions.menu.CloseViaOE')) {
        const contextMenuItemEnability = getTradingActionContextMenuItemEnability(PositionActionEnum.ClosePositionViaOE, params, isEmptySelection, emptySelectionReason);
        items.push({
            type: 'item',
            id: 'closeViaOE',
            icon: SvgIconType.CloseViaOE,
            text: Resources.getResource('panel.positions.menu.CloseViaOE'),
            tooltip: Resources.getResource('panel.positions.CloseViaOE.FIFO'),
            disabled: contextMenuItemEnability.isDisabled,
            disabledReason: contextMenuItemEnability.disabledReason,
            onClick: () => processAction(PositionActionEnum.ClosePositionViaOE, params.allPositions, params.selectedPositions, params.appSettings, params.tradingProvider, params.applicationScreensProvider, PlacedFrom.WEB_POSITIONS_PANEL_CONTEXT_MENU)
        });
    }
    if (!Resources.isHidden('panel.positions.menu.MutualClose') &&
        getActionVisibility(PositionActionEnum.Mutual, params.allPositions, params.selectedPositions, params.tradingProvider) === true) {
        const contextMenuItemEnability = getTradingActionContextMenuItemEnability(PositionActionEnum.Mutual, params, isEmptySelection, emptySelectionReason);
        items.push({
            type: 'item',
            id: 'mutualClose',
            text: Resources.getResource('panel.positions.menu.MutualClose'),
            disabled: contextMenuItemEnability.isDisabled,
            disabledReason: contextMenuItemEnability.disabledReason,
            onClick: () => processAction(PositionActionEnum.Mutual, params.allPositions, params.selectedPositions, params.appSettings, params.tradingProvider, params.applicationScreensProvider, PlacedFrom.WEB_POSITIONS_PANEL_CONTEXT_MENU)
        });
    }
    return items;
}
function createExerciseOptionContextMenuItems(params, isEmptySelection, emptySelectionReason) {
    const items = [];
    if (!Resources.isHidden('panel.positions.menu.ExercisePosition') &&
        getActionVisibility(PositionActionEnum.ExerciseOption, params.allPositions, params.selectedPositions, params.tradingProvider) === true) {
        const contextMenuItemEnability = getTradingActionContextMenuItemEnability(PositionActionEnum.ExerciseOption, params, isEmptySelection, emptySelectionReason);
        items.push({
            type: 'item',
            id: 'exercisePosition',
            text: Resources.getResource('panel.positions.menu.ExercisePosition'),
            disabled: contextMenuItemEnability.isDisabled,
            disabledReason: contextMenuItemEnability.disabledReason,
            onClick: () => processAction(PositionActionEnum.ExerciseOption, params.allPositions, params.selectedPositions, params.appSettings, params.tradingProvider, params.applicationScreensProvider, PlacedFrom.WEB_POSITIONS_PANEL_CONTEXT_MENU)
        });
    }
    if (!Resources.isHidden('panel.positions.menu.ExerciseCancel') &&
        getActionVisibility(PositionActionEnum.ExerciseCancel, params.allPositions, params.selectedPositions, params.tradingProvider) === true) {
        const contextMenuItemEnability = getTradingActionContextMenuItemEnability(PositionActionEnum.ExerciseCancel, params, isEmptySelection, emptySelectionReason);
        items.push({
            type: 'item',
            id: 'exerciseCancel',
            text: Resources.getResource('panel.positions.menu.ExerciseCancel'),
            disabled: contextMenuItemEnability.isDisabled,
            disabledReason: contextMenuItemEnability.disabledReason,
            onClick: () => processAction(PositionActionEnum.ExerciseCancel, params.allPositions, params.selectedPositions, params.appSettings, params.tradingProvider, params.applicationScreensProvider, PlacedFrom.WEB_POSITIONS_PANEL_CONTEXT_MENU)
        });
    }
    return items;
}
function createTradingActionContextMenuItem(params) {
    const items = [];
    const selectedPositions = params.selectedPositions;
    const isEmptySelection = isValidArray(selectedPositions) === false;
    const emptySelectionReason = Resources.getResource('panel.positions.menu.NoSymbolInfoDisabled.tt');
    if (!Resources.isHidden('panel.positions.menu.Modify')) {
        const contextMenuItemEnability = getTradingActionContextMenuItemEnability(PositionActionEnum.PositionModifying, params, isEmptySelection, emptySelectionReason);
        items.push({
            type: 'item',
            id: 'modify',
            text: Resources.getResource('panel.positions.menu.Modify'),
            disabled: contextMenuItemEnability.isDisabled,
            disabledReason: contextMenuItemEnability.disabledReason,
            onClick: () => processAction(PositionActionEnum.PositionModifying, params.allPositions, params.selectedPositions, params.appSettings, params.tradingProvider, params.applicationScreensProvider, PlacedFrom.WEB_POSITIONS_PANEL_CONTEXT_MENU)
        });
    }
    const closeItems = createCloseContextMenuItems(params, isEmptySelection, emptySelectionReason);
    if (closeItems.length > 0) {
        items.push(...closeItems);
    }
    const exerciseItems = createExerciseOptionContextMenuItems(params, isEmptySelection, emptySelectionReason);
    if (exerciseItems.length > 0) {
        items.push(...exerciseItems);
    }
    if (!Resources.isHidden('panel.positions.menu.ModifyProductType') &&
        getActionVisibility(PositionActionEnum.ModifyProductType, params.allPositions, params.selectedPositions, params.tradingProvider) === true) {
        const contextMenuItemEnability = getTradingActionContextMenuItemEnability(PositionActionEnum.ModifyProductType, params, isEmptySelection, emptySelectionReason);
        items.push({
            type: 'item',
            id: 'modifyProductType',
            text: Resources.getResource('panel.positions.menu.ModifyProductType'),
            disabled: contextMenuItemEnability.isDisabled,
            disabledReason: contextMenuItemEnability.disabledReason,
            onClick: () => processAction(PositionActionEnum.ModifyProductType, params.allPositions, params.selectedPositions, params.appSettings, params.tradingProvider, params.applicationScreensProvider, PlacedFrom.WEB_POSITIONS_PANEL_CONTEXT_MENU)
        });
    }
    return items;
}
// #endregion Trading actions
function createViewContextMenuItem(params) {
    if (Resources.isHidden('panel.positions.menu.View')) {
        return null;
    }
    const items = [];
    if (!Resources.isHidden('panel.positions.menu.DisplayTrades')) {
        items.push({
            type: 'item',
            id: 'displayTrades',
            text: Resources.getResource('panel.positions.menu.DisplayTrades'),
            checked: params.isDisplayTrades,
            onClick: params.onDisplayTradesClick
        });
    }
    if (!Resources.isHidden('panel.positions.menu.ShowToolbar')) {
        items.push({
            type: 'item',
            id: 'showToolbar',
            text: Resources.getResource('panel.positions.menu.ShowToolbar'),
            checked: params.isShowToolbar,
            onClick: params.onShowToolbarClick
        });
    }
    if (!Resources.isHidden('panel.positions.menu.ShowTotals')) {
        items.push({
            type: 'item',
            id: 'showTotals',
            text: Resources.getResource('panel.positions.menu.ShowTotals'),
            checked: params.isShowTotals,
            onClick: params.onShowTotalsClick
        });
    }
    if (!Resources.isHidden('panel.positions.menu.ShowGroupQtyAs')) {
        items.push({
            type: 'item',
            id: 'showGroupQtyAs',
            text: Resources.getResource('panel.positions.menu.ShowGroupQtyAs.locKey'),
            subitems: [
                {
                    type: 'item',
                    id: 'showGroupQtyAsTotal',
                    text: Resources.getResource('panel.positions.menu.ShowGroupQtyAs.Total'),
                    checked: params.tableQuantityTotalMode === TableQuantityTotalMode.Total,
                    onClick: () => {
                        params.onTableQuantityTotalModeClick(TableQuantityTotalMode.Total);
                    }
                },
                {
                    type: 'item',
                    id: 'showGroupQtyAsNet',
                    text: Resources.getResource('panel.positions.menu.ShowGroupQtyAs.Net'),
                    checked: params.tableQuantityTotalMode === TableQuantityTotalMode.Net,
                    onClick: () => {
                        params.onTableQuantityTotalModeClick(TableQuantityTotalMode.Net);
                    }
                }
            ]
        });
    }
    if (items.length === 0) {
        return null;
    }
    return {
        type: 'item',
        id: 'view',
        icon: SvgIconType.ViewGroup,
        text: Resources.getResource('panel.positions.menu.View'),
        subitems: items
    };
}
export function createContextMenuItems(params) {
    const items = [];
    const tradingActionContextMenuItems = createTradingActionContextMenuItem(params);
    if (tradingActionContextMenuItems.length > 0) {
        items.push(...tradingActionContextMenuItems);
    }
    const viewContextMenuItem = createViewContextMenuItem(params);
    if (viewContextMenuItem !== null) {
        items.push(viewContextMenuItem);
        items.push({ id: 'separator-view', type: 'separator' });
    }
    if (!Resources.isHidden('panel.instrumentsInfo')) {
        const isDisabled = isValidArray(params.selectedPositions) === false;
        items.push({
            type: 'item',
            id: 'symbol-info',
            icon: SvgIconType.InfoTool,
            text: Resources.getResource('panel.instrumentsInfo'),
            disabled: isDisabled,
            disabledReason: isDisabled ? Resources.getResource('panel.positions.menu.NoSymbolInfoDisabled.tt') : null,
            onClick: () => params.applicationScreensProvider.showSymbolInfoScreen(params.selectedPositions[0].getInstrument(), params.selectedPositions[0].getAccount())
        });
    }
    const groupByContextMenuItem = createGroupByContextMenuItem(params.columns, params.groupByColumn, params.onGroupByClick);
    if (groupByContextMenuItem !== null) {
        items.push(groupByContextMenuItem);
    }
    return items;
}
